import { InjectionToken } from '@angular/core';

export const CARE_PLAN_VIEW_GROUP = 'BSB_Careplan_View';
export const CARE_PLAN_EDIT_GROUP = 'BSB_Careplan_Edit';
export const CARE_PLAN_LOWER_ENV_ADMIN_GROUP = 'internal_service_admin';
export const CARE_PLAN_ADMIN_GROUP = 'BSB_CarePlan_Admin';

export interface CarePlanAccess {
  canView(): boolean;
  canEdit(): boolean;
  canOverrideOptionQualification?(): boolean;
}

/** Runtime Okta-group access supplied by the application shell. */
export const CARE_PLAN_ACCESS = new InjectionToken<CarePlanAccess>(
  'CARE_PLAN_ACCESS',
);
